import type { AnyAction } from '@reduxjs/toolkit';

import { actions as entitiesActions } from 'app/redux/actions/entities';
import { actions as navigationActions } from 'app/redux/actions/navigation';

type Config = {
  loading: boolean;
  appReady: boolean;
  apiUrl: string;
};

type EntityID = Exclude<string, keyof Config>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Navigation mixes typed Config fields with dynamic entity keys; no safe union exists
type EntitiesState = Partial<Record<EntityID, any>>;

export type Navigation = Partial<Config> & EntitiesState;

export function navigation(
  state: Navigation = {},
  action: AnyAction
): Navigation {
  switch (action.type) {
    case navigationActions.APP_READY:
      return {
        ...state,
        appReady: true,
      };
    case entitiesActions.START_FETCH_ENTITY:
      return {
        ...state,
        [action.entity]: { ...state[action.entity], loading: true },
      };
    case entitiesActions.FETCH_ENTITY_SUCCESS:
      return {
        ...state,
        [action.entity]: {
          ...state[action.entity],
          loading: false,
          ready: true,
        },
      };
    case entitiesActions.FETCH_ENTITY_SUCCESS_WITH_PARAMS:
      return {
        ...state,
        [action.entity]: {
          ...state[action.entity],
          loading: false,
          ready: true,
        },
      };
    case navigationActions.SET_CURRENCY:
      return {
        ...state,
        currency: action.currency,
      };
    default:
      return state;
  }
}
